import React, { useEffect } from "react";
import styles from "./style.module.scss";

import icon from "../../assets/image/Frame.png";
import bold from "../../assets/image/boldx.jpg";

import Modal from "../../components/Modal/Modal";

import { getYandexUsersArray } from "../../controllers/APIDataCallController/APIDataCallController";
import { addYandexUsers } from "../../controllers/APIDataCallController/APIDataCallController";

function Admin() {
  const [openModal, setOpenModal] = React.useState(false);
  const [yandexUsers, setYandexUsers] = React.useState([]);

  useEffect(() => {
    const fetchYandexUsers = async () => {
      const res = await getYandexUsersArray();
      setYandexUsers(res);
    };
    fetchYandexUsers();
  }, []);

  console.log(yandexUsers);

  return (
    <div className={styles.load}>
      <img className={styles.load__logo_bold} src={bold} alt="Logo" />
      <div className={styles.load__logo_container}>
        <img className={styles.load__logo} src={icon} alt="Logo" />
        <div>
          <h2>Fire Safety</h2>
          <p>Center</p>
        </div>
      </div>
      <div className={styles.load__cpb}>
        <h3 className={styles.load__cpb__title}>CPBZero</h3>
      </div>
      <button className={styles.load__user} onClick={() => setOpenModal(true)}>
        Добавить пользователя
      </button>
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <div className={styles.load__section}>
            <h2 className={styles.load__section__title}>Добавить пользователя</h2>
            <div className={styles.load__section__users}>
              {yandexUsers.length > 0 ? (
                yandexUsers.map((user) => (
                  <div key={user.id}>
                    <p>Имя: {user.real_name}</p>
                    <p>Email: {user.email}</p>
                    <p className={styles.load__section__id}>Yandex ID: {user.yandexId}</p>
                    <button
                      className={styles.load__section__btn}
                      onClick={() => addYandexUsers(user)}
                    >
                      Добавить
                    </button>
                  </div>
                ))
              ) : (
                <p>Нет доступных пользователей</p>
              )}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Admin;
